// Force recompile
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { UserCardComponent } from 'src/app/components/cards/user-card/user-card.component';
import { BusinessCardComponent } from 'src/app/components/cards/business-card/business-card.component';
import { CommunityCardComponent } from 'src/app/components/cards/community-card/community-card.component';
import { WidgetModule } from 'src/app/widget/widget.module';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NodataFoundComponent } from 'src/app/widget/nodata-found/nodata-found.component';


@Component({
  selector: 'app-all-user-list',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule,
UserCardComponent, BusinessCardComponent, CommunityCardComponent, WidgetModule,
    NG_ICON_DIRECTIVES, CommonSkeletonComponent, InfiniteScrollModule,
    NodataFoundComponent,
  ],
  templateUrl: './all-user-list.component.html',
  styleUrls: ['./all-user-list.component.scss']
})
export class AllUserListComponent implements OnInit, OnDestroy {

  BuninessPageData: any;
  businessPages: any[] = [];
  users: any[] = [];
  communityPages;

  // Window infinite scroll with OFFSET paging. The cursor form this replaced sent
  // each list's last sort values back, and the first of those is the relevance
  // score - a float that travels as a JSON number and returns as a double that is
  // not bit-for-bit the original. Rows sharing the cursor's score were then served
  // again, so a page could repeat the whole group it ended on and a list ran past
  // its own total with duplicates.
  //
  // /home/profiles/search?ALL runs TWO Elasticsearch queries per call (people,
  // then business) and applies the same offset to each. Paging both at once put a
  // fresh slab of businesses under every new slab of people, so business cards
  // kept being pushed down the grid on each scroll and re-flowed to new
  // positions — and because one shared offset advanced by the requested page
  // size rather than by rows received, the shorter list skipped rows outright.
  //
  // People are first priority, businesses second, so the two lists are now paged
  // in SEQUENCE: `loadPhase` stays on USER until every user row is on screen and
  // only then moves to BUSINESS. Each phase offsets by the rows it actually
  // holds (same as the People / Business tabs do), so nothing is skipped.
  pageSize = 15;
  userTotalCount = 0;
  businessTotalCount = 0;
  /** Which list the next page belongs to. Flips to BUSINESS exactly once, when
   *  the people list is exhausted; a new search resets it to USER. */
  private loadPhase: 'USER' | 'BUSINESS' = 'USER';
  // Rows RECEIVED per list, which is what the next request offsets by.
  //
  // These cannot be `users.length` / `businessPages.length` any more, because the
  // append below now drops rows already on screen. If a page comes back entirely
  // duplicated, the kept length would not move, the next request would ask for the
  // same offset, and the feed would loop on one page for ever. Counting what the
  // server SENT keeps the cursor moving whether a row is kept or discarded.
  private userOffset = 0;
  private businessOffset = 0;
  endReached = false;
  isLoadingMore = false;
  loadMoreCards = new Array(3);
  // The text the current list was fetched with (route term or the page's own
  // search box), so scrolling keeps paging the same result set.
  activeSearch = '';
  term;
  Alldata;
  menuData;
  data;
  photoId;

  CommunityData;

  showSearchData = true;
  showSearchData1 = false;

  // Drives the inline skeleton grid in the feed while a results fetch is in
  // flight (replaces the global spinner for these loads). loaderCards just gives
  // *ngFor a fixed count of placeholder cards to render.
  isLoading = false;
  loaderCards = new Array(6);

  filter:UntypedFormGroup;

  navData;
  name;

  colors: Array<any> = ['hgreen', 'hred', 'horange', 'hyellow'];
  selColor: string;
  srarch: any;
  lenght: any;
  photoId_U: any;
  photoId_B: any;

  constructor(
    private API: ApiService,
    private fb: UntypedFormBuilder,
    private router: Router ,
    private route: ActivatedRoute,
    private util: UtilService
  ) {
  }

  randomColor(val: any): any {
    return '2px solid #' + Math.floor(Math.random() * val).toString(16);
  }

  /** Closed in ngOnDestroy so the queryParams subscription below dies with the
   *  component. The tabs are swapped with *ngIf, so leaving it open kept every
   *  previously-mounted instance alive, each re-running its own search on the
   *  next param change - extra in-flight calls that the visible component's
   *  isLoadingMore guard cannot see, because that flag is per instance. */
  private readonly destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      //  ////// console.log('datanav',data)
      //  this.navaData =data.data;
      //  this.srarch = data.searchData;
      //  // this.name = data.searchData
      this.navData=res.data;
      // Trimmed on the way in too: the nav bar already trims, but a bookmarked or
      // hand-edited URL can still carry a whitespace-only searchData.
      this.srarch = (res.searchData ?? '').trim();
      // this.name = res.searchData;
      if(this.navData!='undefined' && this.srarch != 'undefined'){
        // this.allCombinationData();
        this.allCombinationData();

       }else {
        this.allCombinationData();

        // this.AllUserData();
       }
     });
    // this.allCombinationData();
  }

  allCombinationData(){
    this.activeSearch = this.srarch;
    this.fetchPage(this.pageSize, true);
   }

   get hasMore(): boolean {
    if (this.endReached) {
      return false;
    }
    // Only the list being paged right now decides whether there is more to
    // fetch. Checking both would keep the people phase alive on a businesses-
    // only remainder and vice versa.
    //
    // Compared against rows RECEIVED, not rows kept: a page that was entirely
    // discarded as duplicate still consumed its slice of the total, and measuring
    // the kept length would leave hasMore permanently true.
    return this.loadPhase === 'USER'
      ? this.userOffset < this.userTotalCount
      : this.businessOffset < this.businessTotalCount;
   }

   /**
    * Append `incoming` to `existing`, skipping any row whose id is already on
    * screen. The feed can legitimately receive the same row twice - two requests
    * in flight at once return overlapping slices, and the server re-ranks between
    * them - and `concat` rendered every copy, which is the duplicate-card report.
    * Rows with no id are kept: they cannot be compared, and dropping them would
    * lose data rather than a duplicate.
    */
   private appendUnique(existing: any[], incoming: any[], idKey: string): any[] {
    if (!incoming || incoming.length === 0) {
      return existing;
    }
    const seen = new Set((existing || []).map(row => row?.[idKey]).filter(id => id != null));
    const fresh = incoming.filter(row => {
      const id = row?.[idKey];
      if (id == null) { return true; }
      if (seen.has(id)) { return false; }
      seen.add(id);
      return true;
    });
    return fresh.length ? (existing || []).concat(fresh) : (existing || []);
   }

   // Header count for this tab. Two separate searches feed it, one per list, so
   // the figure shown is their totals added rather than a count the backend
   // returns on its own.
   get allTotalCount(): number {
    return (this.userTotalCount || 0) + (this.businessTotalCount || 0);
   }

   // One request against /home/profiles/search.
   //   reset             — new search / new term: clear both lists and start the
   //                       people phase again from offset 0.
   //   refreshUsersOnly  — re-read the people window already on screen (after a
   //                       connect action) without touching the business list or
   //                       the load phase.
   //   otherwise         — append the next page of whichever list `loadPhase`
   //                       currently points at.
   private fetchPage(pageCount: number, reset: boolean, refreshUsersOnly = false) {
    // Offset by rows actually received, not by pages requested — a page that comes
    // back short must not push the cursor past rows that were never delivered.
    const offSet = (reset || refreshUsersOnly)
      ? 0
      : (this.loadPhase === 'USER' ? this.userOffset : this.businessOffset);
    const data = {
    'search': this.activeSearch,
    'searchContent':'ALL',
    'loginUserId':localStorage.getItem('userId'),
    'page':
        {
        'offSet': offSet,
        'pageCount': pageCount,
        }
    };
    if (reset) {
      this.isLoading = true;
      this.endReached = false;
      this.loadPhase = 'USER';
    } else {
      this.isLoadingMore = true;
    }
    this.API.create('home/profiles/search' , data).subscribe(res => {
      this.isLoading = false;
      this.isLoadingMore = false;
      this.dynamicdata = res;

      //community (not part of the paged search; kept as returned)
      this.CommunityData = res?.communityPages;
      if (this.CommunityData && Array.isArray(this.CommunityData)) {
        this.CommunityData.forEach(element => {
          element.CommunityData = element.logo ? AppSettings.photoUrl + element.logo : null;
          element.communityColor = this.colors[Math.floor(Math.random() * this.colors.length)];
        });
      }

      //users
      const users = (res && Array.isArray(res.users)) ? res.users : [];
      users.forEach(element => {
        element.userImage = element.photo ? AppSettings.photoUrl + element.photo : null;
        element.userColor = this.colors[Math.floor(Math.random() * this.colors.length)];
      });

      //business
      const pages = (res && Array.isArray(res.businessPages)) ? res.businessPages : [];
      pages.forEach(element => {
        // Leave businessLogo as returned: app-business-card prefixes the
        // download URL itself when a logo exists. Prefixing here turned a
        // missing logo into ".../download/undefined", which the browser then
        // requested for every logo-less business before falling back.
        element.businessColor = this.colors[Math.floor(Math.random() * this.colors.length)];
      });

      // Totals are per-list ES hit counts and stay constant across pages. Fall
      // back to the rows received only on the first page — overwriting them
      // mid-scroll with a short page's length would end the list early and
      // wreck the header count.
      this.userTotalCount = res?.page?.userTotalCount
        ?? (reset ? users.length : this.userTotalCount);
      this.businessTotalCount = res?.page?.businessTotalCount
        ?? (reset ? pages.length : this.businessTotalCount);

      if (refreshUsersOnly) {
        // Connection state changed on a card already on screen. Swap in the
        // refreshed people window and leave everything else as it was.
        this.users = users;
        this.Alldata = this.users;
        this.fillViewportIfNeeded();
        return;
      }

      if (reset) {
        this.users = [];
        this.businessPages = [];
        this.userOffset = 0;
        this.businessOffset = 0;
      }

      if (this.loadPhase === 'USER') {
        this.userOffset = offSet + users.length;
        this.users = this.appendUnique(this.users, users, 'userId');
        // Hand over to the business list only once the people list can give no
        // more — either the backend says we hold them all, or it returned an
        // empty page (its total can count rows that don't survive mapping).
        if (users.length === 0 || this.userOffset >= this.userTotalCount) {
          this.loadPhase = 'BUSINESS';
          // This same response already carries the business slice for `offSet`,
          // but it is only usable when it lines up with an empty business list.
          if (offSet === 0 && pages.length > 0) {
            this.businessOffset = pages.length;
            this.businessPages = this.appendUnique(this.businessPages, pages, 'businessId');
          }
        }
      } else if (pages.length === 0) {
        // Nothing came back for an offset we have not filled yet — stop instead
        // of asking for the same offset on every further scroll.
        this.endReached = true;
      } else {
        this.businessOffset = offSet + pages.length;
        this.businessPages = this.appendUnique(this.businessPages, pages, 'businessId');
      }

      if (this.loadPhase === 'BUSINESS'
          && this.businessOffset >= this.businessTotalCount) {
        this.endReached = true;
      }

      this.Alldata = this.users;
      this.fillViewportIfNeeded();
    }, err => {
      this.isLoading = false;
      this.isLoadingMore = false;
    });
   }

   // Fires from the infiniteScroll directive when the window nears the bottom.
   onScroll() {
    if (this.isLoading || this.isLoadingMore || !this.hasMore) {
      return;
    }
    this.fetchPage(this.pageSize, false);
   }

   // On a tall screen one page may not produce a scrollbar, and without a
   // scroll event the directive never fires. After each page renders, pull the
   // next one while the document is still shorter than the window.
   private fillViewportIfNeeded() {
    setTimeout(() => {
      if (this.hasMore && document.documentElement.scrollHeight <= window.innerHeight + 50) {
        this.onScroll();
      }
    }, 0);
   }

   // connect() / cancelConnectionRequest() only change the connection state on a
   // USER card, so refetch just the people window already on screen. Rebuilding
   // both lists (what this used to do) restarted the load phase, which would now
   // discard every business card already paged in, and it also re-requested the
   // business list at the people list's length — the source of the "businesses
   // vanish after the list finishes loading" behaviour.
   private refreshLoaded() {
    this.fetchPage(Math.max(this.pageSize, this.users.length), false, true);
   }

   AllUserData(){
    const data = {'search': this.srarch,
    'searchContent':'ALL',
    'loginUserId':localStorage.getItem('userId'),
    'page': {
            'offSet': 0,
            'pageCount': 50,
            }
    };
    this.util.startLoader()
    this.API.create('home/profiles/searchAll' , data).subscribe(res => {
    this.util.stopLoader()
    this.dynamicdata= res;
    this.businessPages=res.businessPages;
    this.users = res.users;
    this.CommunityData = res.communityPages;
    this.Alldata = this.users;

    this.CommunityData.forEach(element => {
      element.commLog = AppSettings.photoUrl + element.banner;
      element.commColor =this.colors[Math.floor(Math.random() * this.colors.length)];
     });

     this.users.forEach(element => {
      element.userLogo = AppSettings.photoUrl + element.businessLogo;
      element.userColor =this.colors[Math.floor(Math.random() * this.colors.length)];
     });

     this.businessPages.forEach(element => {
      element.businessLogo = AppSettings.photoUrl+ element.businessLogo;
      element.businessColor =this.colors[Math.floor(Math.random() * this.colors.length)];
     });
    },err => {
      this.util.stopLoader();
     });
   }

   businessLink(data){
    // //// console.log('business data :.....',data);
    var data1: any= {};
    data1.businessId = data.businessId;
     this.router.navigate(['business'],{queryParams: data1});
   }

   communityLink(dataLink){
   // //// console.log('communityLink(dataLink) :.....',dataLink);
    var data : any = {};
    data.communityId = dataLink.communityId;
    this.router.navigate(['community'],{queryParams : data});
  }

   searchInput(){
     this.filter = this.fb.group({
      filterDataSearch :['']
     });
   }

   clearInput = new UntypedFormControl();

   clearData(){
     this.clearInput.reset();
  // //// console.log('cleare Data');
   }

   searchData(search){
    // // //// console.log('data....search',search.target.value);
    //  this.showSearchData = false;
    //  this.showSearchData1 = true;

     // Spaces are not a term. Trimming turns "   " back into "" - the same state
     // the box was already in - so the equality check below drops the keystroke
     // instead of refetching both lists for whitespace.
     const term = (this.clearInput.value ?? '').trim();
     if (term === this.activeSearch) {
       return;
     }
     this.activeSearch = term;
     this.fetchPage(this.pageSize, true);
   }

   connect(data){
   // //// console.log('connect data:' ,data)
    data.requestedBy = localStorage.getItem('userId')
    this.util.startLoader()
    this.API.create('user/connect', data).subscribe(res=>{
     // //// console.log('connect data :' , res)
      this.util.stopLoader()
      if(res.code=="00000"){
        //message to show connect request is sent successfully
        // this.requestSent = true
        // this.notConnected = false
        // this.connected = false
        this.refreshLoaded()
        // if()
        setTimeout(function(){ Swal.fire("Request is sent Successfully!"); }, 200);

      }else if(res.code=="88888"){
        // this.requestSent = false
        // this.notConnected = false
        // this.connected = false
      }
    },err => {
      this.util.stopLoader();

     });

  }

  cancelConnectionRequest(data){
    this.util.startLoader()
    this.API.create('user/connect/cancel',data).subscribe(res =>{
      this.util.stopLoader()
     // //// console.log('Cancel Connection : ', res);
      if(res.code === '00000'){
        this.refreshLoaded();
       // //// console.log('Connect request cancelled successfully');
        Swal.fire('Connect request cancelled successfully');
        // this.user.connectionStatus="NOT_CONNECTED";
        // this.initCard();
        // this.requestSent = false
        // this.notConnected = true
        // this.connected = false

      }else if(res.code === '88888'){
       // //// console.log('Unable to Cancel connection');
      }
    },err => {
      this.util.stopLoader();

     });

  }
  dynamicdata(arg0: string, dynamicdata: any) {
    throw new Error("Method not implemented.");
  }

}


